import { fork } from 'redux-saga/effects';

import { onboardingSaga } from './sagas/onboarding';

export const applicationSaga = function* () {
  yield fork(onboardingSaga);
};
